$idle_app $mol_book2_catalog
	menu_title \Idle
	menu_tools /
		<= Telegram $mol_link_source
			Icon <= Telegram_icon $mol_icon_telegram
			uri \https://t.me/h_y_o_o/4484
		<= Sources $mol_link_source uri \https://github.com/Lyumih/idle
	param \game
	spreads *
		dice <= Dice_page $idle_app_dice
		dps <= Dps_page $idle_app_dps
